import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProductListWrapper } from 'src/components/DesignSystem/Widgets2.0/ProductListWrapper';
import FlatList from 'src/components/FlatList';
import { RootState } from 'src/redux/reducers';
import { getThemeColor } from 'src/utils/getThemeColor';

const ProductList = ({ id, name, loadMoreProducts, pagination }) => {
  const themeColor = getThemeColor();
  const { isNextPage = false, products = [] } = pagination[id] || {};

  const { loader } = useSelector((state: RootState) => ({
    loader: state.commonReducer.loader,
  }));

  useEffect(() => {
    loadMoreProducts(id);
  }, [id]);

  return (
    <div
      key={id}
      className="tw-flex tw-flex-col tw-gap-[20px] tw-border-b tw-border-solid tw-border-[#E5E5E5] tw-px-[20px] tw-py-[36px] first:tw-pt-0 md:tw-gap-[36px] md:tw-py-[42px]"
    >
      {!!name && (
        <div
          id={id}
          className="tw-text-[18px]/[24px] tw-font-bold md:tw-text-[24px]/[32px]"
        >
          {name}
        </div>
      )}
      <div>
        <FlatList
          isLoaderVisible={false}
          isNext={isNextPage}
          onScrollEnd={null}
          renderInsideFragment
          renderList={() => (
            <ProductListWrapper
              productList={products}
              oldCardConfigs={{
                showButton: false,
                noTags: false,
              }}
            />
          )}
        />
      </div>
      {isNextPage && !loader && (
        <div className="tw-flex tw-justify-center tw-pt-[16px]">
          <button
            className="tw-w-[194px] tw-cursor-pointer tw-border tw-border-solid tw-bg-transparent tw-py-[10px] tw-text-[15px]/[20px] md:tw-w-[256px] md:tw-py-[12px] md:tw-text-[18px]/[24px]"
            style={{
              color: themeColor,
              borderColor: themeColor,
            }}
            onClick={() => loadMoreProducts(id)}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductList;
